"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.etaDocumentPreview = exports.etaReadinessResponse = exports.etaInvoiceReadiness = exports.etaReadinessQuery = exports.etaIssue = exports.etaConnectionTestResult = exports.updateEtaConnectionRequest = exports.etaConnectionStatusDto = exports.etaConnectionDto = exports.etaTaxRuleOption = exports.etaLastTest = exports.etaTaxMapping = exports.etaIssuerAddress = exports.etaConnectionState = exports.etaEnvironment = void 0;
const zod_1 = require("zod");
const common_1 = require("./common");
/**
 * ربط منظومة الفاتورة الإلكترونية (ETA). الإعداد هنا **تجهيز** فقط: الإرسال الفعلى
 * مطفأ خلف `settings.tax.eInvoice.enabled`، والتوقيع الإلكترونى BLOCKED-TAX.
 *
 * Client Secret لا يخرج من الخادم أبدًا: الرد يحمل «محفوظ» وآخر ٤ أحرف فقط.
 */
/** تجريبية (preprod) افتراضيًا — الإنتاج اختيار صريح للمالك. */
exports.etaEnvironment = zod_1.z.enum(['preprod', 'production']);
/**
 * حالة الربط كما تراها اللوحة:
 *  - `not_configured`: لا بيانات اعتماد محفوظة.
 *  - `untested`: محفوظة ولم تُختبر بعد آخر تغيير.
 *  - `test_failed`: آخر اختبار فشل.
 *  - `connected`: آخر اختبار حصل على token من خادم هوية المنظومة.
 */
exports.etaConnectionState = zod_1.z.enum([
    'not_configured',
    'untested',
    'test_failed',
    'connected',
]);
const text = (max) => zod_1.z.string().trim().min(1).max(max);
/**
 * عنوان الممول كما يُرسل فى المستند. الدولة مصر دائمًا هنا.
 * BLOCKED-TAX: أسماء الحقول وإلزاميتها من هيكل المنظومة المنشور ولم تُختبر رسميًا.
 */
exports.etaIssuerAddress = zod_1.z
    .object({
    governate: text(100),
    regionCity: text(100),
    street: text(200),
    buildingNumber: text(50),
})
    .strict();
/**
 * ربط قاعدة ضريبية داخلية (بمعرّفها الثابت عبر الإصدارات) بنوع الضريبة ونوعها الفرعى
 * فى المنظومة. BLOCKED-TAX: القيم (مثل T1/V009) يختارها مستشار الضرائب لا الكود.
 */
exports.etaTaxMapping = zod_1.z
    .object({
    ruleId: zod_1.z.string().trim().min(1).max(64),
    taxType: zod_1.z
        .string()
        .trim()
        .regex(/^T\d{1,2}$/, 'tax type looks like T1'),
    subType: zod_1.z
        .string()
        .trim()
        .regex(/^[A-Za-z0-9]{1,16}$/, 'sub type is letters and digits'),
})
    .strict();
exports.etaLastTest = zod_1.z.object({
    at: zod_1.z.string(),
    ok: zod_1.z.boolean(),
    environment: exports.etaEnvironment,
    message: zod_1.z.string(),
});
/** قاعدة ضريبية معتمدة للشركة — للاختيار عند ربط أنواع الضريبة. */
exports.etaTaxRuleOption = zod_1.z.object({
    ruleId: zod_1.z.string(),
    nameAr: zod_1.z.string(),
    ratePercent: zod_1.z.string(),
});
exports.etaConnectionDto = zod_1.z.object({
    companyId: common_1.uuid,
    state: exports.etaConnectionState,
    environment: exports.etaEnvironment,
    /** من بيانات الشركة — يُعدَّل من تبويب «الشركة والخيارات» لا هنا. */
    taxpayerRin: zod_1.z.string().nullable(),
    clientId: zod_1.z.string().nullable(),
    secretSaved: zod_1.z.boolean(),
    /** آخر ٤ أحرف للتعرّف فقط — السر نفسه لا يُعاد أبدًا. */
    secretLast4: zod_1.z.string().nullable(),
    activityCode: zod_1.z.string().nullable(),
    branchId: zod_1.z.string(),
    issuerAddress: exports.etaIssuerAddress.nullable(),
    taxMappings: zod_1.z.array(exports.etaTaxMapping),
    taxRules: zod_1.z.array(exports.etaTaxRuleOption),
    lastTest: exports.etaLastTest.nullable(),
    /** `settings.tax.eInvoice.enabled` — الإرسال الفعلى، مطفأ حتى الاعتماد. */
    sendingEnabled: zod_1.z.boolean(),
    /** هل ضُبط مفتاح تعمية الأسرار على الخادم؛ بدونه لا يُحفظ Client Secret. */
    encryptionReady: zod_1.z.boolean(),
    updatedAt: zod_1.z.string().nullable(),
});
/** ما تحتاجه بطاقة اللوحة فقط — يقرؤه كل عضو، بلا Client ID ولا أى سر. */
exports.etaConnectionStatusDto = zod_1.z.object({
    state: exports.etaConnectionState,
    environment: exports.etaEnvironment,
    sendingEnabled: zod_1.z.boolean(),
    lastTestAt: zod_1.z.string().nullable(),
});
/**
 * الحفظ كامل. `clientSecret` غائب = يبقى المحفوظ كما هو، فلا تُطلب إعادة كتابته
 * عند تعديل حقل آخر — والواجهة لا تملكه أصلاً لتعيده.
 */
exports.updateEtaConnectionRequest = zod_1.z
    .object({
    environment: exports.etaEnvironment.default('preprod'),
    clientId: text(128),
    clientSecret: zod_1.z.string().trim().min(8).max(256).optional(),
    /**
     * كود النشاط (ISIC) كما سُجّل فى المنظومة. BLOCKED-TAX: أربعة أرقام افتراض
     * من الهيكل المنشور.
     */
    activityCode: zod_1.z
        .string()
        .trim()
        .regex(/^\d{4}$/, 'activity code is 4 digits'),
    /** كود الفرع فى المنظومة — `0` للفرع الرئيسى. */
    branchId: zod_1.z
        .string()
        .trim()
        .regex(/^\d{1,10}$/, 'branch id is digits')
        .default('0'),
    issuerAddress: exports.etaIssuerAddress.nullable().default(null),
    taxMappings: zod_1.z.array(exports.etaTaxMapping).max(50).default([]),
})
    .strict();
/** نتيجة «اختبار الاتصال» — الـ token نفسه لا يُعاد ولا يُخزَّن. */
exports.etaConnectionTestResult = zod_1.z.object({
    ok: zod_1.z.boolean(),
    environment: exports.etaEnvironment,
    message: zod_1.z.string(),
    testedAt: zod_1.z.string(),
});
/** `blocker` يمنع بناء المستند، و`warning` قد تطلبه المنظومة حسب الحالة. */
exports.etaIssue = zod_1.z.object({
    code: zod_1.z.string(),
    severity: zod_1.z.enum(['blocker', 'warning']),
    message: zod_1.z.string(),
    target: zod_1.z.string().optional(),
});
exports.etaReadinessQuery = zod_1.z
    .object({
    from: common_1.isoDate.optional(),
    to: common_1.isoDate.optional(),
})
    .strict();
exports.etaInvoiceReadiness = zod_1.z.object({
    invoiceId: common_1.uuid,
    number: zod_1.z.string(),
    issueDate: common_1.isoDate,
    customerNameAr: zod_1.z.string(),
    total: common_1.moneyString,
    ready: zod_1.z.boolean(),
    issues: zod_1.z.array(exports.etaIssue),
});
exports.etaReadinessResponse = zod_1.z.object({
    /** ما ينقص الشركة أو الربط نفسه — يمنع كل الفواتير معًا. */
    companyIssues: zod_1.z.array(exports.etaIssue),
    invoices: zod_1.z.array(exports.etaInvoiceReadiness),
    summary: zod_1.z.object({ total: zod_1.z.number().int(), ready: zod_1.z.number().int() }),
});
/** معاينة حمولة فاتورة — المستند غير موقّع، ولا يُرسل من هنا. */
exports.etaDocumentPreview = zod_1.z.object({
    invoiceId: common_1.uuid,
    ready: zod_1.z.boolean(),
    issues: zod_1.z.array(exports.etaIssue),
    /** نص JSON كما سيُرسل (الأرقام حرفية بلا تقريب float)، أو null إن نقص شىء. */
    documentJson: zod_1.z.string().nullable(),
});
//# sourceMappingURL=einvoice.js.map